export let PaymentType = /*#__PURE__*/function (PaymentType) {
  PaymentType["SUBSCRIPTION"] = "subscription";
  PaymentType["RENT"] = "rent";
  PaymentType["PURCHASE"] = "sale";
  PaymentType["MEMBER_ONLY"] = "memberOnly";
  PaymentType["PLAN"] = "plan";
  return PaymentType;
}({});
//# sourceMappingURL=payment-type.js.map